import type { Component } from 'solid-js'
import type { ChannelData, ComparedValue } from '../../../features/engagement/domain/models/community'
import ValueProgressCell from './custom-cells/ValueProgressCell'
import { KPI, KPIType } from '../../../features/analytics/domain/models/kpi'
import { NumericalDataType } from '../../../shared/models/numerical-data-type'

export interface ChannelsTableRowProps {
  readonly channel: ChannelData
  readonly rowNumber: number
}

const ChannelsTableRow: Component<ChannelsTableRowProps> = (props) => {
  const kpi = (id: KPIType, value: ComparedValue) =>
    new KPI(id, value.current, NumericalDataType.Units, value.diff, value.previous)

  return (
    <tr class="hover:bg-gray-50">
      <td class="whitespace-nowrap px-4 py-4 text-center text-gray-700">{props.rowNumber}</td>
      <td class="px-4 py-4">
        <span class="text-sm font-medium text-gray-900">{props.channel.name}</span>
      </td>
      <td class="w-[156px]">
        <ValueProgressCell kpi={kpi(KPIType.ForumPosts, props.channel.posts)} />
      </td>
      <td class="w-[156px]">
        <ValueProgressCell kpi={kpi(KPIType.ForumViews, props.channel.views)} />
      </td>
      <td class="w-[156px]">
        <ValueProgressCell kpi={kpi(KPIType.ForumComments, props.channel.comments)} />
      </td>
      <td class="w-[156px]">
        <ValueProgressCell kpi={kpi(KPIType.ForumUpvotes, props.channel.upvotes)} />
      </td>
    </tr>
  )
}

export default ChannelsTableRow
